/**
 * ChunkWarmup — Pre-carica JS chunks e HTML delle 5 rotte più visitate
 * durante il tempo di idle del browser, DOPO che la HomePage è renderizzata.
 *
 * Effetto:
 *  - Seconda visita / navigazione interna istantanea (<100ms)
 *  - Service Worker pre-popola la cache delle HTML routes
 *  - Zero impatto sul LCP iniziale (gira solo durante idle)
 *  - Skip automatico se connessione lenta (save-data / 2G / slow-2g)
 */
import { useEffect } from 'react';

export default function ChunkWarmup() {
  useEffect(() => {
    // Non saturiamo connessioni lente / Data Saver attivo
    const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conn) {
      if (conn.saveData) return;
      if (['2g', 'slow-2g'].includes(conn.effectiveType)) return;
    }

    const runWarmup = () => {
      // Pre-carica i JavaScript chunk delle pagine più navigate
      // Queste import() risolvono i chunk webpack senza renderizzarli.
      // Se l'utente naviga lì subito dopo, il chunk è già in memoria/cache HTTP.
      Promise.allSettled([
        import('../../pages/SearchPage'),
        import('../../pages/AgencyListPage'),
        import('../../pages/RecentDeathsPage'),
        import('../../pages/BlogPage'),
        import('../../pages/ObituaryDetailPage'),
      ]).catch(() => {});

      // Notifica al Service Worker di pre-cacheare l'HTML delle top routes
      if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
        try {
          navigator.serviceWorker.controller.postMessage({ type: 'WARMUP_ROUTES' });
        } catch (_) {
          /* SW non ancora pronto */
        }
      }
    };

    let idleId;
    if ('requestIdleCallback' in window) {
      idleId = window.requestIdleCallback(runWarmup, { timeout: 8000 });
    } else {
      idleId = setTimeout(runWarmup, 4000);
    }

    return () => {
      if ('cancelIdleCallback' in window && typeof idleId === 'number') {
        try { window.cancelIdleCallback(idleId); } catch (_) {}
      } else if (typeof idleId === 'number') {
        clearTimeout(idleId);
      }
    };
  }, []);

  return null;
}
